/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Columns_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Customize table columns" |
*
* @param {Editor_Table_Columns_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_columns_aria_label = /** @type {((inputs?: Editor_Table_Columns_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Columns_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Personnaliser les colonnes du tableau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tabellenspalten anpassen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Personalizza le colonne della tabella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка столбцов таблицы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Personalizar columnas de la tabla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义表格列")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テーブル列をカスタマイズする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेबल कॉलम को अनुकूलित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Personalizar colunas da tabela")
	return /** @type {LocalizedString} */ ("Customize table columns")
});